import { useTranslation } from 'react-i18next';
import { Button } from '@teo/components';
import { LearningPathSidebarAdd } from '@/constants/sidebar.constants';
// import { CoursesList } from './AddContent/CoursesList';
import { useState, useContext, useEffect } from 'react';
import CourseSettings from './SettingsNodes/CourseSettings';
import HomeSettings from './SettingsNodes/HomeSettings';
import {
  Training,
  Evaluation,
  Flag,
  Import,
  Theme,
} from '@teo/components/icons';
import { axios } from '@/axios';
import { config } from '@/config';
import TrainingSettings from './SettingsNodes/TrainingSettings';
import { AuthContext } from '@/components/Contexts/AuthContext';
import { createRootConect } from './util';
import ThemeSettings from './SettingsNodes/ThemeSettings';
import { NotificationContext } from '@/components/Contexts/NotificationContext';
import { templates } from '@/constants/tempatesImport';
import CoursesList from './AddContent/CoursesList';

const SettingsNode = ({
  learningpathId,
  learningpath,
  setLearningpath,
  setIsLoaderOpen,
  nodeSelected,
  setNodeSelected,
  setThemeNodeSelected,
  authUser,
  handleChangeNode,
  handleRemoveNode,
  handleRemoveChildNode,
  handleReplaceNode,
  handleMakeTheme,
  setIsDraggingDisabled,
  setNodes,
  nodes,
  setEdges,
  edges,
  setHomeImage,
  homeImage,
  categories,
  allCategories,
  refetchCorrection,
  isOwner,
  setNewLpCompetencies,
  newLpCompetencies,
  setLpCompetencies,
  lpCompetencies,
  refetchCompetencies,
}) => {
  const { t } = useTranslation();
  const [selectedCourseType, setSelectedCourseType] = useState('course');
  const [isOpenListCoursesModal, setIsOpenListCoursesModal] = useState(false);
  const [importType, setImportType] = useState('scorm');

  const { setShowNotification } = useContext(NotificationContext);
  const { auth } = useContext(AuthContext);
  const authLang = auth?.user.lang;
  const authOrg = auth?.user?.activeOrganisationId;

  // console.log(nodes);
  // console.log(edges);

  const setProps = {
    handleRemoveNode: handleRemoveNode,
    handleReplaceNode: handleReplaceNode,
    handleMakeTheme: handleMakeTheme,
    setThemeNodeSelected: setThemeNodeSelected,
    setIsDraggingDisabled: setIsDraggingDisabled,
    allCategories: allCategories,
  };

  const handleAddItem = async (type) => {
    if (nodeSelected) {
      if (nodeSelected?.data?.replace) {
        const newTraining = await axios.post(`${config.backend}/trainings`, {
          organisationId: authOrg,
          learningpathId: learningpathId,
          trainingName: t(`pages.learning_path.untitled_${type}`),
          trainingType: type,
          inputScore:
            type === 'evaluation' || type === 'milestone' ? false : true,
          minScore: type === 'milestone' ? 0 : type === 'evaluation' ? 1 : 0.5,
          typeOfTraining:
            type === 'milestone'
              ? 'motivator'
              : type === 'evaluation'
              ? 'internal'
              : 'external',
        });

        handleChangeNode(nodeSelected?.data?.replace, {
          objectId: newTraining?.data?.id,
          picture: null,
          subType: newTraining?.data?.trainingType,
          type: 'training',
        });

        const updatedNodes = nodes.map((item) =>
          item.id === nodeSelected?.id
            ? {
                ...item,
                type: 'customNode',
                data: {
                  learningPathId: learningpathId,
                  nodeID: newTraining?.data?.id,
                  trainingId: newTraining?.data?.id,
                  title: newTraining?.data?.trainingName,
                  description: newTraining?.data?.trainingDescription,
                  type: 'training',
                  courseType: type,
                  mandatory: item?.data?.mandatory,
                  blocking: item?.data?.blocking,
                  notCompleted: item?.data?.notCompleted,
                  notPassed: item?.data?.notPassed,
                  tags: newTraining?.data?.tags,
                  ...setProps,
                },
              }
            : item
        );
        setNodes(updatedNodes);
        setNodeSelected((prev) =>
          updatedNodes?.find((nds) => nds?.id === prev.id)
        );
      } else {
        const edgeConect = createRootConect(nodeSelected, edges);

        const newTraining = await axios.post(`${config.backend}/trainings`, {
          organisationId: authOrg,
          learningpathId: learningpathId,
          trainingName: t(`pages.learning_path.untitled_${type}`),
          trainingType: type,
          inputScore:
            type === 'evaluation' || type === 'milestone' ? false : true,
          minScore: type === 'milestone' ? 0 : type === 'evaluation' ? 1 : 0.5,
          typeOfTraining:
            type === 'milestone'
              ? 'motivator'
              : type === 'evaluation'
              ? 'internal'
              : 'external',
        });

        const newNode = await axios.post(
          `${config.backend}/learningpathnodes`,
          {
            learningpathId: learningpathId,
            objectId: newTraining?.data?.id,
            type: 'training',
            subType: newTraining?.data?.trainingType,
            x: nodeSelected?.position?.x,
            y: nodeSelected?.position?.y,
            roots: edgeConect?.rootsId,
            rootDescriptions: edgeConect?.rootsConect,
            mandatory:
              type === 'milestone' ? true : nodeSelected?.data?.mandatory,
            blocking: true,
            notCompleted: true,
          }
        );

        const createNodeId = newNode?.data?.id;

        if (createNodeId) {
          const uodateEdges = edges?.map((edg) =>
            edg?.target === nodeSelected?.id
              ? {
                  ...edg,
                  target: `${createNodeId}`,
                }
              : edg?.source === nodeSelected?.id
              ? {
                  ...edg,
                  source: `${createNodeId}`,
                }
              : edg
          );
          const updatedNodes = nodes.map((item) =>
            item.id === nodeSelected?.id
              ? {
                  ...item,
                  id: `${createNodeId}`,
                  type: 'customNode',
                  data: {
                    learningPathId: learningpathId,
                    nodeID: newTraining?.data?.id,
                    trainingId: newTraining?.data?.id,
                    title: newTraining?.data?.trainingName,
                    description: newTraining?.data?.trainingDescription,
                    tags: newTraining?.data?.tags,
                    type: 'training',
                    courseType: type,
                    mandatory:
                      type === 'milestone'
                        ? true
                        : nodeSelected?.data?.mandatory,
                    blocking: true,
                    notCompleted: true,
                    notPassed: false,
                    ...setProps,
                  },
                }
              : item
          );
          setEdges(uodateEdges);
          setNodes(updatedNodes);
          setNodeSelected((prev) =>
            updatedNodes?.find((nds) => nds?.id === prev.id)
          );
        }
      }
    }
  };
  const handleAddCourse = async (activeCourse, replace = false) => {
    if (nodeSelected && activeCourse) {
      const newCourseResponse = await axios.post(`${config.backend}/courses`, {
        courseType: activeCourse?.publicationCourseType,
        coursecontentId: activeCourse?.id,
        courseName: activeCourse?.name,
        courseDescription: activeCourse?.description,
        courseImage: activeCourse?.image ? activeCourse?.image : null,
        correctionType: 'immediate',
      });
      const newCourse = newCourseResponse.data;

      if (newCourse?.id) {
        await axios.post(`${config.backend}/courseinfos`, {
          courseId: newCourse?.id,
        });
        // await axios.post(`${config.backend}/membercourses`, {
        //   courseId: newCourse?.id,
        //   organisationId: auth?.user?.activeOrganisationId,
        // });
      }

      if ((nodeSelected?.data?.replace || replace) && newCourse?.id) {
        handleChangeNode(nodeSelected?.data?.replace, {
          name: newCourse?.courseName ? newCourse?.courseName : newCourse?.name,
          objectId: newCourse?.id,
          picture: newCourse?.courseImage
            ? newCourse?.courseImage
            : newCourse?.image
            ? newCourse?.image
            : '/assets/images/opleidingen.jpg',
          subType:
            activeCourse?.publicationType === 'teo'
              ? newCourse?.courseType
              : 'import',
          type: 'course',
        });

        const updatedNodes = nodes.map((item) =>
          item.id === nodeSelected?.id
            ? {
                ...item,
                type: 'customNode',
                data: {
                  learningPathId: learningpathId,
                  nodeID: newCourse?.id,
                  courseId: newCourse?.id,
                  coursecontentId: newCourse?.coursecontentId,
                  title: newCourse?.courseName
                    ? newCourse?.courseName
                    : newCourse?.name,
                  type: 'course',
                  image: newCourse?.courseImage
                    ? newCourse?.courseImage
                    : newCourse?.image
                    ? newCourse?.image
                    : '/assets/images/opleidingen.jpg',
                  courseType:
                    activeCourse?.publicationType === 'teo'
                      ? newCourse?.courseType
                      : 'import',
                  publicationCourseType: newCourse?.courseType,
                  tags: newCourse?.tags,
                  description: newCourse?.description,
                  mandatory: item?.data?.mandatory,
                  blocking: item?.data?.blocking,
                  notCompleted: item?.data?.notCompleted,
                  notPassed: item?.data?.notPassed,
                  ...setProps,
                },
              }
            : item
        );
        setNodes(updatedNodes);
        setNodeSelected((prev) =>
          updatedNodes?.find((nds) => nds?.id === prev.id)
        );

        setIsOpenListCoursesModal(false);
      } else {
        const edgeConect = createRootConect(nodeSelected, edges);

        const newNode = await axios.post(
          `${config.backend}/learningpathnodes`,
          {
            learningpathId: learningpathId,
            objectId: newCourse?.id,
            type: 'course',
            subType:
              activeCourse?.publicationType === 'teo'
                ? newCourse?.courseType
                : 'import',
            x: nodeSelected?.position?.x,
            y: nodeSelected?.position?.y,
            roots: edgeConect?.rootsId,
            rootDescriptions: edgeConect?.rootsConect,
            mandatory: nodeSelected?.data?.mandatory,
            blocking: true,
            notCompleted: true,
          }
        );

        const createNodeId = newNode?.data?.id;

        if (createNodeId) {
          const uodateEdges = edges?.map((edg) =>
            edg?.target === nodeSelected?.id
              ? {
                  ...edg,
                  target: `${createNodeId}`,
                }
              : edg?.source === nodeSelected?.id
              ? {
                  ...edg,
                  source: `${createNodeId}`,
                }
              : edg
          );
          const updatedNodes = nodes.map((item) =>
            item.id === nodeSelected?.id
              ? {
                  ...item,
                  id: `${createNodeId}`,
                  type: 'customNode',
                  data: {
                    learningPathId: learningpathId,
                    nodeID: newCourse?.id,
                    courseId: newCourse?.id,
                    coursecontentId: newCourse?.coursecontentId,
                    title: newCourse?.courseName
                      ? newCourse?.courseName
                      : newCourse?.name,
                    type: 'course',
                    image: newCourse?.courseImage
                      ? newCourse?.courseImage
                      : newCourse?.image
                      ? newCourse?.image
                      : '/assets/images/opleidingen.jpg',
                    courseType:
                      activeCourse?.publicationType === 'teo'
                        ? newCourse?.courseType
                        : 'import',
                    publicationCourseType: newCourse?.courseType,
                    tags: newCourse?.tags,
                    description: newCourse?.courseDescription,
                    mandatory: nodeSelected?.data?.mandatory,
                    blocking: true,
                    notCompleted: true,
                    notPassed: false,
                    ...setProps,
                  },
                }
              : item
          );

          setEdges(uodateEdges);
          setNodes(updatedNodes);
          setNodeSelected((prev) =>
            updatedNodes?.find((nds) => nds?.id === prev.id)
          );

          setIsOpenListCoursesModal(false);
        }
      }
    }
  };

  const handleAddImport = async () => {
    try {
      const id = templates?.[authLang]?.[importType];
      const newId = await axios.post(`${config.backend}/publish/copy/${id}`);
      const publicationId = newId?.data?.id;
      const [membercourse, coursecontent] = await Promise.allSettled([
        axios.post(`${config.backend}/membercoursecontents`, {
          role: 90,
          coursecontentId: publicationId,
          organisationId: authOrg,
        }),
        axios.put(`${config.backend}/coursecontent/${publicationId}`, {
          authorId: auth?.user?.id,
          publicationStatus: 'concept',
          publicationCourseType: 'course',
          name: t('pages.learning_path.new_imported_content'),
          description: '',
        }),
      ]);

      if (coursecontent.status === 'fulfilled') {
        const importCourse = coursecontent.value.data;
        handleAddCourse(importCourse);
      }
    } catch (e) {
      console.error(e);
      setIsLoaderOpen(false);
      setShowNotification({
        message: e?.response?.data?.message || e?.message,
        delay: 10000,
      });
    }
  };

  const themeReset = async (updatedNodes, newNodeId) => {
    const updatedNodesTheme = await Promise.all(
      updatedNodes.map(async (nds) => {
        if (
          nds?.data?.courseType === 'learningpath' &&
          nds?.data?.nodeID === newNodeId
        ) {
          try {
            const response = await axios.get(
              `${config.backend}/learningpathnodedetails?learningpathId=${nds?.data?.nodeID}&organisationId=${authOrg}`
            );
            return {
              ...nds,
              data: {
                ...nds.data,
                child: response?.data,
              },
            };
          } catch (error) {
            console.error('Error fetching child nodes:', error);
            return nds;
          }
        }

        return nds;
      })
    );

    return updatedNodesTheme;
  };

  const handleAddTheme = async () => {
    let newNodes;
    let newNodeId;
    if (nodeSelected) {
      if (nodeSelected?.data?.replace) {
        const newLP = await axios.post(`${config.backend}/learningpaths`, {
          lpAccess: 'protected',
          lpName: t('pages.learning_path.untitled_theme'),
          lpIsRoot: false,
          parentId: learningpathId,
        });
        const newLearningpathId = newLP?.data?.id;

        await axios.post(`${config.backend}/memberlearningpaths`, {
          learningpathId: newLearningpathId,
          organisationId: authOrg,
        });

        await handleChangeNode(nodeSelected?.data?.replace, {
          objectId: newLearningpathId,
          picture: null,
          subType: 'learningpath',
          type: 'learningpath',
        });

        const updatedNodes = nodes.map((item) =>
          item.id === nodeSelected?.id
            ? {
                ...item,
                type: 'customNode',
                data: {
                  learningPathId: learningpathId,
                  nodeID: newLP?.data?.id,
                  trainingId: false,
                  title: newLP?.data?.lpName,
                  description: newLP?.data?.lpDescription,
                  type: 'learningpath',
                  courseType: 'learningpath',
                  tags: newLP?.data?.tags,
                  mandatory: item?.data?.mandatory,
                  blocking: item?.data?.blocking,
                  notCompleted: item?.data?.notCompleted,
                  notPassed: item?.data?.notPassed,
                  ...setProps,
                },
              }
            : item
        );
        newNodeId = newLearningpathId;
        newNodes = updatedNodes;
        setNodes(updatedNodes);
        setNodeSelected((prev) =>
          updatedNodes?.find((nds) => nds?.id === prev.id)
        );
      } else {
        const edgeConect = createRootConect(nodeSelected, edges);
        const newLP = await axios.post(`${config.backend}/learningpaths`, {
          lpAccess: 'protected',
          lpName: t('pages.learning_path.untitled_theme'),
          lpIsRoot: false,
        });
        const newLearningpathId = newLP?.data?.id;

        axios.post(`${config.backend}/memberlearningpaths`, {
          learningpathId: newLearningpathId,
          organisationId: authOrg,
        });

        const newNode = await axios.post(
          `${config.backend}/learningpathnodes`,
          {
            learningpathId: learningpathId,
            objectId: newLearningpathId,
            type: 'learningpath',
            subType: 'learningpath',
            x: nodeSelected?.position?.x,
            y: nodeSelected?.position?.y,
            roots: edgeConect?.rootsId,
            rootDescriptions: edgeConect?.rootsConect,
            mandatory: nodeSelected?.data?.mandatory,
            blocking: true,
            notCompleted: true,
          }
        );

        const createNodeId = newNode?.data?.id;

        if (createNodeId) {
          const uodateEdges = edges?.map((edg) =>
            edg?.target === nodeSelected?.id
              ? {
                  ...edg,
                  target: `${createNodeId}`,
                }
              : edg?.source === nodeSelected?.id
              ? {
                  ...edg,
                  source: `${createNodeId}`,
                }
              : edg
          );
          const updatedNodes = nodes.map((item) =>
            item.id === nodeSelected?.id
              ? {
                  ...item,
                  id: `${createNodeId}`,
                  type: 'customNode',
                  data: {
                    child: [],
                    learningPathId: learningpathId,
                    nodeID: newLearningpathId,
                    title: newLP?.data?.lpName,
                    description: newLP?.data?.lpDescription,
                    tags: newLP?.data?.tags,
                    type: 'learningpath',
                    courseType: 'learningpath',
                    mandatory: nodeSelected?.data?.mandatory,
                    blocking: true,
                    notCompleted: true,
                    notPassed: false,
                    ...setProps,
                  },
                }
              : item
          );
          newNodeId = newLearningpathId;
          newNodes = updatedNodes;
          setEdges(uodateEdges);
          setNodes(updatedNodes);
          setNodeSelected((prev) =>
            updatedNodes?.find((nds) => nds?.id === prev.id)
          );
        }
      }
      // refetchCorrection();
      setTimeout(async () => {
        const updatedNodes = await themeReset(newNodes, newNodeId);
        setNodes(updatedNodes);
      }, 500);
    }
  };

  const courseType = authUser?.useCourse;
  const assessmentType = authUser?.useAssessment;
  const vacancyType = authUser?.useLeervacature;
  const instructionType = authUser?.useInstruction;

  return (
    <>
      {nodeSelected && (
        <>
          {nodeSelected?.data?.empty && (
            <div className="flex h-full flex-col px-2 py-5">
              <h4 className="mb-4 px-3 text-base">
                {t('pages.learning_path.add_new')}
              </h4>
              <div className="flex flex-col gap-2">
                {LearningPathSidebarAdd?.map((el, i) => {
                  if (!courseType && el?.type === 'course') return null;
                  if (!assessmentType && el?.type === 'assessment') return null;
                  if (!vacancyType && el?.type === 'leervacature') return null;
                  if (!instructionType && el?.type === 'instructions')
                    return null;
                  return (
                    <div key={i}>
                      <Button
                        onClick={() => {
                          setSelectedCourseType(el.type);
                          setIsOpenListCoursesModal(true);
                        }}
                        variant="ghost"
                        className="flex gap-2 !px-3"
                      >
                        <el.icon
                          className={`h-5 w-5 fill-black ${
                            el?.type === 'leervacature' && 'text-black'
                          }`}
                        />
                        {t(el.text)}
                      </Button>
                    </div>
                  );
                })}
                <div>
                  <Button
                    variant="ghost"
                    className="flex gap-2 !px-3"
                    onClick={() => handleAddTheme()}
                  >
                    <Theme className="text-black" />
                    {t('pages.learning_path.theme')}
                  </Button>
                </div>
                <div>
                  <Button
                    variant="ghost"
                    className="flex gap-2 !px-3"
                    onClick={() => handleAddItem('training')}
                  >
                    <Training className="text-black" />
                    {t('pages.learning_path.training')}
                  </Button>
                </div>
                <div>
                  <Button
                    variant="ghost"
                    className="flex gap-2 !px-3"
                    onClick={() => handleAddItem('evaluation')}
                  >
                    <Evaluation className="text-black" />
                    {t('pages.learning_path.evaluation')}
                  </Button>
                </div>
                <div>
                  <Button
                    variant="ghost"
                    className="flex gap-2 !px-3"
                    onClick={() => handleAddItem('milestone')}
                  >
                    <Flag className="text-black" />
                    {t('pages.learning_path.milestone')}
                  </Button>
                </div>
                <div>
                  <Button
                    variant="ghost"
                    className="flex gap-2 !px-3"
                    onClick={() => handleAddImport()}
                  >
                    <Import className="text-black" />
                    {t('pages.learning_path.import_external')}
                  </Button>
                </div>
              </div>
              <div className="mt-auto text-center">
                <Button
                  variant="ghost"
                  className="!text-error-04"
                  onClick={() => handleRemoveNode(nodeSelected)}
                >
                  {t('pages.learning_path.delete_item')}
                </Button>
              </div>
            </div>
          )}

          {nodeSelected?.data?.type === 'learningpath' && (
            <ThemeSettings
              learningpathId={learningpathId}
              nodeSelected={nodeSelected}
              handleChangeNode={handleChangeNode}
              handleRemoveNode={handleRemoveNode}
              setNodes={setNodes}
              nodes={nodes}
              setEdges={setEdges}
              edges={edges}
              categories={categories}
              allCategories={allCategories}
            />
          )}

          {nodeSelected?.data?.type === 'course' && (
            <CourseSettings
              learningpathId={learningpathId}
              nodeSelected={nodeSelected}
              setIsLoaderOpen={setIsLoaderOpen}
              handleChangeNode={handleChangeNode}
              handleRemoveNode={handleRemoveNode}
              handleMakeTheme={handleMakeTheme}
              handleRemoveChildNode={handleRemoveChildNode}
              setNodes={setNodes}
              nodes={nodes}
              setEdges={setEdges}
              edges={edges}
            />
          )}
          {nodeSelected?.data?.type === 'training' && (
            <TrainingSettings
              learningpathId={learningpathId}
              authOrg={authOrg}
              nodeSelected={nodeSelected}
              handleChangeNode={handleChangeNode}
              handleRemoveNode={handleRemoveNode}
              handleMakeTheme={handleMakeTheme}
              handleRemoveChildNode={handleRemoveChildNode}
              setNodes={setNodes}
              nodes={nodes}
              setEdges={setEdges}
              edges={edges}
              authUser={authUser}
            />
          )}
        </>
      )}

      {(!nodeSelected || nodeSelected?.data?.type === 'homepage') && (
        <HomeSettings
          learningpathId={learningpathId}
          learningpath={learningpath}
          setLearningpath={setLearningpath}
          setNodes={setNodes}
          nodes={nodes}
          setHomeImage={setHomeImage}
          homeImage={homeImage}
          categories={categories}
          allCategories={allCategories}
          isOwner={isOwner}
          auth={auth}
          authLang={authLang}
          setNewLpCompetencies={setNewLpCompetencies}
          newLpCompetencies={newLpCompetencies}
          setLpCompetencies={setLpCompetencies}
          lpCompetencies={lpCompetencies}
          refetchCompetencies={refetchCompetencies}
        />
      )}

      {isOpenListCoursesModal && (
        <CoursesList
          closeModal={() => setIsOpenListCoursesModal(false)}
          handleAddCourse={handleAddCourse}
          courseType={selectedCourseType}
        />
      )}
    </>
  );
};
export default SettingsNode;
